import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaPerformance = React.lazy(() =>
    import('../NebulaPerformance')
);
const nebulaPerformanceRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_PERFORMANCE_PAGE,
        element: <NebulaPerformance />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaPerformanceRoutesRegistry;
